// Generated from content/*.md. Do not edit directly.
export const CONTENT = {
  "de": {
    "bautagebuch": {
      "title": "Baufortschritt in Oberbozen",
      "updated": "2026-08-08",
      "intro": "Aktuelle, datierte Einblicke in die Entwicklung des Projekts.",
      "items": [
        [
          "08. August 2026 – Decke über dem 1. Obergeschoss",
          "Die Rohbauphase schreitet sichtbar voran. Laut aktuellem Baustellenfoto ist die Decke über dem 1. Obergeschoss hergestellt; als nächstes folgen weitere tragende Bauteile und der Ausbau."
        ],
        [
          "Juni 2026 – Decke über der Garage betoniert",
          "Die Rohbauphase schreitet voran. Die Decke über der Garage ist betoniert; als nächstes folgen weitere tragende Bauteile und der Ausbau."
        ]
      ]
    },
    "fakten": {
      "title": "Projekt-Fakten",
      "updated": "2026-06-17",
      "intro": "Die wichtigsten überprüfbaren Fakten zum Wohnprojekt Am Waldrand in Oberbozen.",
      "items": [
        [
          "Standort",
          "Oberbozen, Ritten, Südtirol auf rund 1.200 Metern Höhe, mit Dolomitenblick und Nähe zur Rittner Seilbahn."
        ],
        [
          "Einheiten",
          "Das Projekt umfasst 11 Wohnungen mit etwa 65 bis 123 Quadratmetern und zwei bis vier Zimmern."
        ],
        [
          "Ausstattung",
          "Geplant sind KlimaHaus-Standard, Panoramaterrassen, Gärten und geschützte Tiefgaragenstellplätze."
        ],
        [
          "Kontakt",
          "TRES IMMO ist per Formular, E-Mail, Telefon und WhatsApp erreichbar. Die Verfügbarkeit wird laufend aktualisiert."
        ]
      ]
    },
    "faq": {
      "title": "FAQ zum Wohnungskauf in Oberbozen",
      "updated": "2026-06-17",
      "intro": "Die wichtigsten Antworten zum Projekt Am Waldrand am Ritten.",
      "items": [
        [
          "Wo liegt das Projekt?",
          "Am Waldrand liegt in Oberbozen auf dem Ritten in Südtirol, mit direkter Nähe zu Natur, Dorfzentrum und Rittner Seilbahn."
        ],
        [
          "Sind die Wohnungen als Ferienwohnung nutzbar?",
          "Das Projekt ist auf zeitgemäßes Wohnen und eine flexible Nutzung als Ferienwohnung ausgelegt. Die individuelle rechtliche Situation sollte vor dem Kauf geprüft werden."
        ],
        [
          "Welche Wohnungen sind verfügbar?",
          "Die aktuelle Verfügbarkeit wird über die Einheitenübersicht und die Propstack-Daten aktualisiert. Für Preise und Grundrisse senden wir gerne das Exposé."
        ],
        [
          "Welcher Energiestandard ist geplant?",
          "Das Projekt wird nach dem KlimaHaus-Standard mit einem auf das alpine Klima abgestimmten Energiekonzept umgesetzt."
        ]
      ]
    },
    "ratgeber": {
      "title": "Wohnen am Ritten und in Oberbozen",
      "updated": "2026-06-17",
      "intro": "Oberbozen verbindet alpine Ruhe, gute Erreichbarkeit und die Nähe zu Bozen.",
      "items": [
        [
          "Leben zwischen Natur und Stadt",
          "Die Rittner Seilbahn verbindet Oberbozen in kurzer Zeit mit Bozen. Gleichzeitig beginnen Spazier- und Wanderwege direkt vor der Haustür."
        ],
        [
          "Immobilienkauf in Südtirol",
          "Neben Lage und Architektur zählen Nutzung, Steuern, Nebenkosten und der Energiestandard. Wir empfehlen eine persönliche Beratung für die individuelle Situation."
        ],
        [
          "Warum Neubau?",
          "Neubauwohnungen bieten planbare Qualität, moderne Haustechnik und zeitgemäße Grundrisse. Am Waldrand kommt der Blick auf die Dolomiten hinzu."
        ]
      ]
    }
  },
  "en": {
    "bautagebuch": {
      "title": "Construction progress in Oberbozen",
      "updated": "2026-08-08",
      "intro": "Dated updates from the project development.",
      "items": [
        [
          "8 August 2026 – slab above the first floor",
          "Construction is progressing. The latest site photograph shows the slab above the first floor completed; the next structural works will continue section by section."
        ],
        [
          "June 2026 – garage ceiling concreted",
          "Construction is progressing. The ceiling above the garage has been concreted and the next structural works are underway."
        ]
      ]
    },
    "fakten": {
      "title": "Project facts",
      "updated": "2026-06-17",
      "intro": "The key verifiable facts about the residential project in Oberbozen.",
      "items": [
        [
          "Location",
          "Oberbozen on the Ritten plateau in South Tyrol, at around 1,200 metres, with Dolomite views and access to the cable car."
        ],
        [
          "Units",
          "The project comprises 11 apartments of approximately 65 to 123 square metres, with two to four rooms."
        ]
      ]
    },
    "faq": {
      "title": "FAQ about buying in Oberbozen",
      "updated": "2026-06-17",
      "intro": "Key answers about the residential project on the Ritten plateau.",
      "items": [
        [
          "Where is the project located?",
          "At the Forest’s Edge is located in Oberbozen on the Ritten plateau in South Tyrol, close to nature, the village and the Ritten cable car."
        ],
        [
          "Can the apartments be used as holiday homes?",
          "The project is designed for contemporary alpine living and flexible use. Individual legal circumstances should be checked before purchase."
        ],
        [
          "What energy standard is planned?",
          "The project follows the KlimaHaus standard with an energy concept adapted to the alpine climate."
        ]
      ]
    },
    "ratgeber": {
      "title": "Living on the Ritten and in Oberbozen",
      "updated": "2026-06-17",
      "intro": "Oberbozen combines alpine calm, strong connections and proximity to Bolzano.",
      "items": [
        [
          "Nature and city",
          "The Ritten cable car connects Oberbozen with Bolzano in a short time. Walking and hiking routes start right outside the home."
        ],
        [
          "Buying property in South Tyrol",
          "Location, use, additional costs and energy standards are important factors for a personal consultation."
        ]
      ]
    }
  },
  "it": {
    "bautagebuch": {
      "title": "Avanzamento lavori a Soprabolzano",
      "updated": "2026-08-08",
      "intro": "Aggiornamenti datati dallo sviluppo del progetto.",
      "items": [
        [
          "8 agosto 2026 – solaio sopra il primo piano",
          "La costruzione procede. Secondo la fotografia aggiornata, il solaio sopra il primo piano è stato realizzato; seguono le prossime opere strutturali."
        ],
        [
          "Giugno 2026 – solaio del garage gettato",
          "La costruzione procede. Il solaio sopra il garage è stato gettato e seguono le prossime opere strutturali."
        ]
      ]
    },
    "fakten": {
      "title": "Dati del progetto",
      "updated": "2026-06-17",
      "intro": "I dati principali e verificabili del progetto residenziale a Soprabolzano.",
      "items": [
        [
          "Posizione",
          "Soprabolzano sul Renon, Alto Adige, a circa 1.200 metri, con vista sulle Dolomiti e vicino alla funivia."
        ],
        [
          "Unità",
          "Il progetto comprende 11 appartamenti da circa 65 a 123 metri quadrati, con due-quattro locali."
        ]
      ]
    },
    "faq": {
      "title": "FAQ sull’acquisto a Soprabolzano",
      "updated": "2026-06-17",
      "intro": "Le risposte più importanti sul progetto residenziale sul Renon.",
      "items": [
        [
          "Dove si trova il progetto?",
          "Ai margini del bosco si trova a Soprabolzano sul Renon, vicino alla natura, al paese e alla funivia del Renon."
        ],
        [
          "Gli appartamenti possono essere usati come casa vacanze?",
          "Il progetto è pensato per una vita alpina contemporanea e per un utilizzo flessibile. La situazione giuridica individuale va verificata prima dell’acquisto."
        ],
        [
          "Qual è lo standard energetico?",
          "Il progetto segue lo standard CasaClima con un concetto energetico adatto al clima alpino."
        ]
      ]
    },
    "ratgeber": {
      "title": "Vivere sul Renon e a Soprabolzano",
      "updated": "2026-06-17",
      "intro": "Soprabolzano unisce tranquillità alpina, collegamenti e vicinanza a Bolzano.",
      "items": [
        [
          "Natura e città",
          "La funivia del Renon collega Soprabolzano con Bolzano in poco tempo. Sentieri e passeggiate iniziano direttamente davanti a casa."
        ],
        [
          "Acquistare in Alto Adige",
          "Posizione, utilizzo, costi accessori e standard energetico sono elementi importanti da valutare con una consulenza personale."
        ]
      ]
    }
  }
};
